<template>
    <b-input size="sm" 
             v-model="displayValue" 
             type="number"
             @blur="isInputActive = false"
             @focus="isInputActive = true">
    </b-input>
</template>

<script>
export default {
  name: "InputNumberDecimalFormat",
  props: {
    value: {
      type: Number,
      default: ""
    },
    arrayIndex: {
      type: Number,
      default: ""
    },
    coordinateIndex: {
      type: Number,
      default: ""
    }
  },
  data: function() {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function() {
        if(this.isInputActive) {
          return this.value.toString();
        } else {
          return (Math.round(this.value * 100) / 100).toString();
        }
      },
      set: function(modified) {
        let newValue = parseFloat(modified);
        if(isNaN(newValue)) {
          newValue = 0;
        }

        this.$emit('valueChanged', newValue, this.arrayIndex, this.coordinateIndex);
      }
    },
  }
};
</script>